/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Trial_ContinueInputs */



/**
* | output |
* | --- |
* | "Continue Trial" |
*
* @param {Audio_Description_Export_Trial_ContinueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_trial_continue = /** @type {((inputs?: Audio_Description_Export_Trial_ContinueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Trial_ContinueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer l'essai")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortsetzung des Verfahrens")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua la prova")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжить судебное разбирательство")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar la prueba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续审判")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トライアルを続ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सतत् परीक्षण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Continuar o julgamento")
	return /** @type {LocalizedString} */ ("Continue Trial")
});